import { createRoute } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';
import { IntegrationsListPage } from './IntegrationsListPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/integrations',
  component: IntegrationsListPage,
  loader: () => ({
    crumb: 'Integrations',
  }),
});
